import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const CreatorGenreContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
  
`